import { Typography } from '@mui/material'
import { useTranslate } from '@tolgee/react'

interface Props {
  serializedPositions: string | null
}

export const IssueCardPositions = ({ serializedPositions }: Props) => {
  const { t } = useTranslate()
  if (!serializedPositions) return null
  return (
    <Typography variant='caption'>
      {t('positions', 'Positions')}: {serializedPositions}
    </Typography>
  )
}
